var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('bread-crumb')],1),_c('open-modal-timer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }